import { CMSRender } from '@/components/cms-render';
import type { JwtAgentPayload } from '@/utils/agent';
import { isValidJwtToken } from '@/utils/agent';
import { getGlobalStore } from '@/utils/store';
import { useSearch } from '@tanstack/react-router';
import { jwtDecode } from 'jwt-decode';
import React from 'react';

const Home = () => {
  const { agentToken } = useSearch({
    from: '/_layout/',
    select: (search) => ({
      agentToken: search['agent-token'],
      genesysConversationId: search.conversation_id,
    }),
  });
  const { setAgentName } = getGlobalStore();
  React.useEffect(() => {
    const isAgentTokenValid = agentToken && isValidJwtToken(agentToken);
    if (isAgentTokenValid) {
      const decodedToken = jwtDecode<JwtAgentPayload>(agentToken);
      setAgentName(decodedToken.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <CMSRender />;
};

export default Home;
